import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { ArrowUpRight, FlaskConical, Menu, Search, Library } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import Logo from "@/components/Logo";
import { APP_URL } from "@/lib/config";
import { cn } from "@/lib/utils";

const navLink = ({ isActive }) =>
  cn(
    "relative rounded-lg px-3 py-2 text-[15px] text-muted-foreground transition-colors hover:text-foreground",
    isActive && "font-medium text-foreground after:absolute after:inset-x-3 after:-bottom-0.5 after:h-0.5 after:rounded-full after:bg-primary",
  );

// উচ্চতা h-16 (৬৪px) বদলাবেন না — Live Try-র sticky ট্যাব (top-16) আর প্রিভিউ কলাম (top-20) এটার ওপর নির্ভর করে
export default function Header() {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <header className="no-print sticky top-0 z-30 border-b border-border bg-background/85 backdrop-blur-md">
      <div className="container flex h-16 items-center justify-between gap-4">
        <Link to="/" aria-label="মুমতাহিন গ্যালারি — হোম" className="rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
          <Logo />
        </Link>

        {/* ডেস্কটপ */}
        <nav aria-label="মূল মেনু" className="hidden items-center gap-1 md:flex">
          <NavLink to="/papers" className={navLink}>
            প্রশ্নপত্র
          </NavLink>
          <NavLink to="/try" className={navLink}>
            Live Try
          </NavLink>
          <Button asChild variant="outline" size="sm" className="ml-3">
            <a href={APP_URL} target="_blank" rel="noopener noreferrer">
              মূল অ্যাপ
              <ArrowUpRight aria-hidden="true" />
            </a>
          </Button>
        </nav>

        {/* মোবাইল */}
        <div className="flex items-center gap-1 md:hidden">
          <Button asChild variant="ghost" size="icon" aria-label="প্রশ্নপত্রের তালিকা ও খোঁজ">
            <Link to="/papers">
              <Search aria-hidden="true" />
            </Link>
          </Button>
          <Button variant="ghost" size="icon" aria-label="মেনু খুলুন" onClick={() => setOpen(true)}>
            <Menu aria-hidden="true" />
          </Button>
        </div>
      </div>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" className="flex w-[82%] max-w-xs flex-col gap-0 p-0">
          <div className="border-b border-border p-5 pr-12">
            <SheetTitle className="sr-only">মেনু</SheetTitle>
            <SheetDescription className="sr-only">সাইটের পেজগুলোর তালিকা</SheetDescription>
            <Logo size={28} />
          </div>
          <nav aria-label="মোবাইল মেনু" className="flex flex-col gap-1 p-3">
            <Link onClick={close} to="/papers" className="flex items-center gap-3 rounded-xl px-3 py-3.5 text-base hover:bg-accent">
              <Library className="h-5 w-5 text-primary" aria-hidden="true" />
              প্রশ্নপত্র খুঁজুন
            </Link>
            <Link onClick={close} to="/try" className="flex items-center gap-3 rounded-xl px-3 py-3.5 text-base hover:bg-accent">
              <FlaskConical className="h-5 w-5 text-primary" aria-hidden="true" />
              Live Try — সাইন আপ ছাড়াই
            </Link>
          </nav>
          <div className="mt-auto border-t border-border p-4">
            <Button asChild className="w-full" size="lg">
              <a href={APP_URL} target="_blank" rel="noopener noreferrer">
                মূল অ্যাপে যান
                <ArrowUpRight aria-hidden="true" />
              </a>
            </Button>
          </div>
        </SheetContent>
      </Sheet>
    </header>
  );
}
